import React from 'react'
import styles from './styles.module.scss'
import htmr from 'htmr'

type SectionHeaderProps = {
  title?: string
  className?: string
  inline?: boolean
  variant?: 'default' | 'left_aligned'
}

const SectionHeader = ({
  title,
  className = '',
  inline,
  variant = 'default'
}: SectionHeaderProps) => {
  if (!title) return null
  return (
    <div
      className={`${styles.sectionHeader} ${
        inline ? styles.sectionHeader_inline : ''
      } ${styles[variant]} ${className}`}
    >
      {title && <h2>{htmr(title)}</h2>}
    </div>
  )
}

export default SectionHeader
